module.exports = __webpack_public_path__ + "img/main-1.e11e252f.svg";